<template>
  <div class="novo-video" :style="{'minHeight':minHeight}">
    <img :style="{display:'block',width:width}" :src="poster" alt="" v-show="!videoLoad">
    <video
      v-show="videoLoad"
      ref="videoRef"
      :src="src"
      :loop="loop"
      muted
      :width="width"
      :poster="poster"
    >您的浏览器不支持vedio</video>
  </div>
</template>
<script>
export default {
  /**
   * @name: NovoVideo
   * @desc: 视频组件
   * @author: 刘毅豪(liuyihao@krspace.cn)
   * @props: src {String} 默认值时空，视频的资源地址
   * @props: width {String,Number} 组件的宽，默认值是空
   * @props: poster {String} 视频播放前的图片资源地址，默认值时空
   * @props: delayTime {String，Number} 默认值是0，占位图停留的时间
   * @props: stop {Boolean} 默认值是fase，控制视频播放或者暂停，并回到开始位置
   * @emit: canplaythrough 视频加载完成 【dom(视频元素节点)】
   */
  props: {
    src: {
      type: String,
      default: ""
    },
    width: {
      type: [String, Number],
      default: ""
    },
    poster: {
      type: String,
      default: ""
    },
    delayTime: {
      default: 0,
      type: [Number, String]
    },
    stop: {
      type: Boolean,
      default: false
    },
    minHeight:{
      type:[String,Number],
      default:''
    }
  },
  data() {
    return {
      videoLoad: false,
      loop: true
    };
  },
  watch: {
    stop(value) {
      const dom = this.$refs["videoRef"];
      if (this.stop) {
        dom.currentTime = 0;
        dom.pause();
      } else {
        dom.play();
      }
    }
  },
  mounted() {
    const dom = this.$refs["videoRef"];
    dom.addEventListener("canplaythrough", this.videoLoadListen, false);
  },
  methods: {
    videoLoadListen() {
      
      const dom = this.$refs["videoRef"];
     
      this.$emit('canplaythrough',dom);
      dom.play();
      if (!this.delayTime) {
        this.videoLoad = true;
      } else {
        setTimeout(() => {
          this.videoLoad = true;
        }, this.delayTime);
      }

      dom.removeEventListener("canplaythrough", this.videoLoadListen, false);
    }
  }
};
</script>
<style lang="scss" scoped>
.novo-video {
}
</style>



// WEBPACK FOOTER //
// src/components/novo-video/index.vue